import React from 'react';
import './ProjectManagement.css';

const InfoPanel = () => {
  return (
    <aside className="info-panel" aria-label="Painel informativo do projeto">
      <h3>ℹ️ Regras e Dicas de Projeto</h3>
      <ul>
        <li>Resumo do projeto tem limite de 300 caracteres.</li>
        <li>Campos obrigatórios: Nome e Resumo.</li>
        <li>Status: Ativo, Concluído ou Inativo.</li>
        <li>Ícone pode ser emoji ou texto curto.</li>
        <li>Projeto de demonstração não conta nos indicadores oficiais.</li>
        <li>O acesso do projeto pode ser configurado depois.</li>
      </ul>
      <div className="info-note">
        <p>
          Dica: Use a busca para localizar projetos rapidamente. Ao editar, o botão
          "Atualizar projeto" só habilita quando houver mudanças.
        </p>
      </div>
    </aside>
  );
};

export default InfoPanel;
